module.exports = __webpack_public_path__ + "img/ic_courier_hanging.887a3be3.svg";